export default __webpack_public_path__ + "static/media/GLOSSARY.e6432c31.pdf";